import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { BsFillRocketTakeoffFill, BsXCircleFill, BsCheckSquareFill, BsFillQuestionCircleFill } from "react-icons/bs";
import { BiLogoSketch, BiParty } from "react-icons/bi";
import party from "../../images/part.png"
import Rocket from "../../images/rocket.png"
import DO_Donot from "../../images/Do_dont.png"
import Unexpected_Responses from "../../images/Unexpected_Responses.png"
import Crystalball from "../../images/Crystalball.png"

import "./Faq.scss";
const SuggestedFaq = ({ t }) => {
    return (
        <div className="FaqSection">
            <div className="row  m-0">
                <div className="col-md-12">
                    <div className="mb-3">
                        <h4>Frequently Asked Questions </h4>
                    </div>
                    <div className="row m-0">
                        <div className="col-md-4 p-2">
                            <div className="card">

                                <div className="card-body">
                                    <div className="text-center p-2 pb-3 cardHead">
                                        <img src={party} />
                                        <h4 className="m-0">Welcome</h4>
                                    </div>
                                    <p>
                                        Welcome to CWD (Chat With Data), an innovative way to explore and interact with data on the Ecodrisil ESG Xpress Copilot. We’re excited to have you join us as we pioneer this new feature together. CWD aims to simplify the complexity of data exploration, putting powerful insights at your fingertips.
                                    </p>
                                    <h6 className="">Key Points: </h6>
                                    <ul>
                                        <li>
                                            Currently focused on quantitative data, and soon expanding into qualitative data and new features.
                                        </li>
                                        <li>
                                            Your participation in this BETA phase is crucial—together we are shaping the future of ESG data analysis.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 p-2">
                            <div className="card">
                                <div className="card-body">
                                    <div className="text-center p-2 pb-3 cardHead">
                                        <img src={Rocket} />
                                        <h4 className="m-0">Get Started</h4>
                                    </div>
                                    <p>
                                        Discover how easy it is to begin using CWD. Dive into your organization's data like never before by leveraging natural language queries for quick and intuitive exploration.
                                    </p>
                                    <h6 className="">Key Points: </h6>
                                    <ul>
                                        <li>
                                            <b>Log In</b> to the Ecodrisil ESG Xpress Copilot and locate the CWD feature.
                                        </li>
                                        <li>
                                            <b>Sample Questions</b> are available above the chat input field to help guide you.
                                        </li>
                                        <li>
                                            Ask questions such as:
                                            <ul>
                                                <li>"What is our organization's total carbon emissions in the first quarter?" </li>
                                                <li>"What is the average training hours per employee in the first quarter?" </li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <h6 className="">Visualizations Available: </h6>
                                    <ul>
                                        <li>Generate line charts, bar charts, pie charts, or view data as tables to gain a comprehensive understanding of your insights. </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 p-2">
                            <div className="card">

                                <div className="card-body">
                                    <div className="text-center p-2 pb-3 cardHead">
                                        <img src={DO_Donot} />
                                        <h4 className="m-0">Dos and Don’ts</h4>
                                    </div>
                                    <p>
                                        Ensure the best experience by following these guidelines for using CWD effectively.
                                    </p>
                                    <h6 className="">Dos:  </h6>
                                    <ul>
                                        <li>
                                            <b>Ask Clear, Specific Questions:</b> The more specific your query, the more accurate the response.
                                        </li>
                                        <li>
                                            <b>Use "Chain of Thoughts":</b> View CWD's reasoning to better understand how it arrived at an answer.
                                        </li>
                                        <li>
                                            <b>Provide Feedback:</b> If a response seems off, let us know—your feedback directly impacts CWD’s improvement.
                                        </li>
                                    </ul>
                                    <h6 className="">Don’ts:  </h6>
                                    <ul>
                                        <li><b>Avoid Hypotheticals:</b> Don’t ask questions like "How can we reduce emissions?" as CWD may offer answers that aren't grounded in your real data.  </li>
                                        <li><b>No External Comparisons:</b> CWD is designed to work specifically with your organization's data, not for comparing it with external entities. </li>
                                        <li><b>Unavailable Data Requests:</b> Avoid questions about data that’s not part of your organization's metrics. </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 p-2">
                            <div className="card">
                                <div className="card-body">
                                    <div className="text-center p-2 pb-3 cardHead">
                                        <img src={Unexpected_Responses} />
                                        <h4 className="m-0">Handling Unexpected Responses</h4>
                                    </div>
                                    <p>
                                        CWD is in its BETA phase and continuously learning, which means there may be occasional inaccuracies. Here’s how you can handle it.
                                    </p>
                                    <h6 className="">Key Points: </h6>
                                    <ul>
                                        <li>
                                            <b>Check the "Chain of Thoughts":</b> This feature shows you the AI’s thought process, helping you understand how it reached a particular answer.
                                        </li>
                                        <li>
                                            <b>Refine Your Question:</b> Sometimes rephrasing your question will yield better results.
                                        </li>
                                        <li>
                                            <b>Provide Feedback:</b> Use the feedback button to report inaccuracies. Your feedback is crucial for improving CWD.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 p-2">
                            <div className="card">

                                <div className="card-body">
                                    <div className="text-center p-2 pb-3 cardHead">
                                        <img src={Crystalball} />
                                        <h4 className="m-0">Future Features and Capabilities</h4>
                                    </div>

                                    <p>
                                        CWD is just getting started! We're continually working to expand its capabilities, making it even more powerful.
                                    </p>
                                    <h6 className="">Upcoming Features: </h6>
                                    <ul>
                                        <li>
                                            <b>Qualitative Data Integration:</b> We're adding qualitative data soon to help provide more comprehensive insights.
                                        </li>
                                        <li>
                                            <b>New Types of Visualizations:</b> Future updates will include even more visualization types to better communicate your data.
                                        </li>
                                        <li>
                                            <b>Expanded Functionality:</b> Your feedback helps us prioritize new features, like advanced customization and comparison capabilities.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                    <p>Stay tuned as we continue to improve and add new dimensions to CWD! </p>
                </div>
            </div>
        </div>
    );
};
export default withTranslation()(SuggestedFaq);